import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
  wrapper: {
    width: '100%',
    paddingBottom: '30px',
    marginBottom: '30px',
    borderBottom: '1px solid #E5E5E5',
    [theme.breakpoints.down('sm')]:{
      width: '95%'
    }
  },
  selectRoot: {
    width: '100%',
    height: '36px',
    padding: '0',
    color: '#000',
    '&:focus': {
      backgroundColor: '#FFFFFF'
    }
  },
  label: {
    marginBottom: 6,
    color: '#071B27',
    textTransform: 'uppercase',
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '0.035em'
  },
  inputRoot: {
    width: '100%',
    border: '1px solid #BECEDA',
    borderRadius: '3px',
    color: '#838383',
    fontSize: '13px',
    '&:hover': {
      border: '1px solid #41B7D7'
    }
  },
  menuList: {
    border: '1px solid #F0F0F0',
    padding: '0',
    minWidth: '140px',
    boxShadow: '1px 2px 15px rgba(0,0,0, 0.08)',
    borderRadius: '4px'
  },
  menuItemRoot: {
    color: '#666666',
    '&:hover': {
      color: '#000000'
    }
  },
  error: {
    boxShadow: 'none',
    border: '1px solid #EB5757',
    '&:hover': {
      border: '1px solid #EB5757'
    }
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    color: '#FFFFFF',
    backgroundColor: '#005a81',
    borderRadius: '3px',
    margin: 2
  },
  deleteChipIcon: {
    width: '14px',
    height: '14px',
    color: '#fff'
  }
}));
